import userInfo from "@/components/toast/userInfo.vue";
import { store } from "@/observable/store";
import { getProfile } from "@/model/javaApi/apis";
import { get, isObject } from "lodash";
const UserLoginMixin = {
  data() {
    return {
      profileLoading: false,
      profile: {
        phone: "",
        name: "",
        idCardNo: "",
      },
    };
  },
  components: { userInfo },
  computed: {
    logined() {
      return store.uid && store.uid != 0;
    },
  },
  methods: {
    getProfile() {
      this.profileLoading = true;
      getProfile()
        .then((res) => {
          const data = get(res, "data.data");
          if (isObject(data)) {
            this.profile = {
              ...this.profile,
              ...data,
            };
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.profileLoading = false;
        });
    },
  },
};

export default UserLoginMixin;
